<template>
    <div class="coreDriverBox">
        <!-- <div class="chainTitle">核心概念</div> -->
        <div v-if="coreConcept.length>0" class="box">
            <div id="mainConcept" class="main" style="width: 100%;height:100%;"></div>
            <CoreConceptList v-if="isClickFlag" ></CoreConceptList>
        </div>
        <DataEmpty v-if="coreConcept.length==0&&isEnd"></DataEmpty>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import CoreConceptList from '../companyCom/coreConceptList.vue'
  import DataEmpty from '../dataEmpty.vue'
  export default {
    name: 'coreConcept',
    data() {
        return {
            coreConcept: [],
            isClickFlag : false,
            paramsInfo:{},
            isEnd:false
        }
    },
    computed: {...mapState(['indexSearchInfo','productRouterInfo','conceptList'])},
    components:{ DataEmpty,CoreConceptList },
    created(){
        this.paramsInfo = this.productRouterInfo
        this.getCompanyCoreConcept(this.productRouterInfo);
    },
    methods: {
        //获取核心概念
        getCompanyCoreConcept( params ){
            this.isEnd = false
            this.$store.dispatch('getCompanyCoreConcept',{coCode:params.coCode}).then( res => {
                this.isEnd == true
                if( res.status == 200 ){
                    this.coreConcept = res.data.data
                    if( this.coreConcept.length>0 ){
                        this.showGraph(60);
                    }
                }
            })
        },
        //展示关系图
        showGraph(num){
            let that = this,elList=[],myChart = [],data = [], links = [];
            let color = ['#7c5d57','#b25b61','#b87c73','#b07e5c','#628086','#868975','#bfa370','#7e9176','#5e9283','#768696','#9c7979','#aca3b6','#b4b4b4','#9fa47d','#aea799','#b78a89','#90906e','#96a08d','#9da4ac','#7e90a4','#7992b4','#7a7281','#977eb3','#b2a793','#a8a369'];
            this.coreConcept.forEach(function( item,index ){
                data.push({
                    value : item.conceptName,
                    name : item.conceptName,
                    symbolSize : 30,
                    draggable: true,
                    code : item.conceptCode,
                    remark : item.remark,
                    itemStyle: {
                        normal: {
                            // color: that.getRandomColor()
                            color: color[index]
                        }
                    }
                })
                links.push({
                        source:  that.productRouterInfo.name,
                        target:  item.conceptName
                })
            })
            var option = {
                title: {text: ''},
                tooltip: {
                    show: true,
                    trigger: 'item'
                },
                animation:false,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    symbol: 'circle',
                    symbolSize: 20,
                    draggable: true,
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            fontWeight: 500,
                            fontSize: 16,
                            position:'top',
                            color:'#333',
                        },
                    },
                    itemStyle: {
                        normal: {
                            label: {
                                textStyle: {
                                    // 用 itemStyle.normal.label.textStyle.fontSize 來更改餅圖上項目字體大小
                                    fontSize: num/4
                                },
                                show: true,
                                fontWeight: 500,
                                fontSize: 14
                            }
                        }
                    },
                    force: {                // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                                    // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                        repulsion: 300,            // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                        edgeLength:105      // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                                                    // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                                                        // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                    },
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    data: data,
                    tooltip: {
                        // formatter: '{b}',
                        formatter: function(params){ //触发之后返回的参数，这个函数是关键
                            // console.log(params);
                            if ( params.data.conceptCode ) { //如果触发节点
                                return params.data.name; //返回标签
                            } else {
                                return params.data.remark;
                            }
                        },
                        backgroundColor: 'rgba(50,50,50,0.8)'
                    },
                    lineStyle: {
                        normal: {
                            opacity: 0.5,
                            width: 1,
                            curveness: 0
                        }
                    }
                }
                ]
            };
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('mainConcept'))
                myChart.setOption(option);
                myChart.on('click', function (param) {
                    if(param.data.source&&param.data.target){
                        return;
                    }
                    if(!param.data.code){
                        that.isClickFlag = false;
                        return;
                    }else{
                        that.$store.dispatch('conceptList', param.data)
                        that.isClickFlag = true;
                        let params = {
                            type: 'product',
                            name:param.data.name,
                            industry:param.data.industry,
                            productCode:param.data.productCode
                        }
                    }
                });
            })            
        },
        //随机颜色，十六进制方法；
        getRandomColor( ) {
            return '#'+Math.floor(Math.random()*0xffffff).toString(16);
        }
    },
    mounted() {},
  }
</script>

<style lang="scss" src="../../../sass/productInfo/coreDriver.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/companyCom/coreConcept.vue